const eventBus = {
  events: {},
  subscribe(eventName, callback) {
    this.events[eventName] = this.events[eventName] || [];
    this.events[eventName].push(callback);
  },
  unsubscribe(eventName) {
    delete this.events[eventName];
  },
  emit(eventName, data) {
    if (this.events[eventName]) {
      this.events[eventName].forEach((callback) => callback(data));
    }
  },
};

export default eventBus;
